import { render, staticRenderFns } from "./ViewDeals.vue?vue&type=template&id=31403bf0&scoped=true"
import script from "./ViewDeals.vue?vue&type=script&lang=js"
export * from "./ViewDeals.vue?vue&type=script&lang=js"
import style0 from "./ViewDeals.vue?vue&type=style&index=0&id=31403bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31403bf0",
  null
  
)

export default component.exports